import { render, staticRenderFns } from "./BroadcastModal.vue?vue&type=template&id=386daa4c&scoped=true&"
import script from "./BroadcastModal.vue?vue&type=script&lang=js&"
export * from "./BroadcastModal.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastModal.vue?vue&type=style&index=0&id=386daa4c&prod&lang=scss&scoped=true&"
import style1 from "./BroadcastModal.vue?vue&type=style&index=1&id=386daa4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386daa4c",
  null
  
)

export default component.exports